import React, { useState } from "react";
import axios from "axios";
import { Loader2, Lock } from "lucide-react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/admin/login`, { email, password });
      localStorage.setItem("lc_admin_token", data.token);
      localStorage.setItem("lc_admin_email", data.admin.email);
      toast.success(`Welcome back, ${data.admin.name}`);
      onLogin(data);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-dark text-white flex items-center justify-center p-5 noise" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex w-14 h-14 rounded-2xl bg-lime text-dark items-center justify-center mb-4"><Lock size={22}/></div>
          <h1 className="font-display text-4xl">Admin Console</h1>
          <p className="text-white/60 text-sm mt-2">Last Cut Landscaping — internal access only</p>
        </div>
        <form onSubmit={submit} className="bg-white/5 backdrop-blur border border-white/10 rounded-3xl p-7 space-y-4">
          <div>
            <label className="block text-xs uppercase tracking-wider text-white/60 mb-2">Email</label>
            <input
              type="email"
              required
              autoFocus
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-login-email"
              className="w-full px-4 py-3 rounded-xl bg-white/10 border border-white/15 text-white placeholder:text-white/40 focus:outline-none focus:border-lime"
              placeholder="admin@lastcutlandscaping.com"
            />
          </div>
          <div>
            <label className="block text-xs uppercase tracking-wider text-white/60 mb-2">Password</label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-login-password"
              className="w-full px-4 py-3 rounded-xl bg-white/10 border border-white/15 text-white placeholder:text-white/40 focus:outline-none focus:border-lime"
              placeholder="••••••••"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full bg-lime text-dark font-bold py-3 rounded-xl hover:bg-lime/90 disabled:opacity-60 flex items-center justify-center gap-2 transition"
          >
            {loading ? <Loader2 size={16} className="animate-spin" /> : null}
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
        <p className="text-center text-xs text-white/40 mt-6">Forgot credentials? Contact your developer.</p>
      </div>
    </div>
  );
}
